module.exports = __webpack_public_path__ + "img/biologicalsciences-h-474x356.c973ff0e.jpg";